import React, { Fragment, useState } from "react";
import { Button, Result, Space, Tooltip, message } from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import axiosInstance from "../../utils/axiosInstance";
import type { SizeType } from "antd/es/config-provider/SizeContext";
import { useHistory, useParams } from "react-router-dom";
import "../../styles/exportButton.css";

interface IProps {
  resourceid: string | undefined;
  getFilters: () => Promise<any>;
}

const ExportButton = (props: IProps) => {
  const [size, setSize] = useState<SizeType>("large");
  const [inLoading, setInLoading] = useState<boolean>(false);

  const handleOnClick = async () => {
    setInLoading(true);
    const filters = await props.getFilters();

    try {
      const response = await axiosInstance({
        method: "post",
        url: `/resources/${props.resourceid}/export`,
        data: {
          tabName: filters.reportTabName, 
          filters: filters.filter,
        },
      });

      setInLoading(false);

      const result: any = response.data;

      if (response.status === 200) {
        message.success(
          "Su solicitud de descarga se ha enviado con éxito. Recibirá una notificación cuando su archivo esté listo.",
          7
        );
      }
    } catch (error) {
      setInLoading(false);
      const result: any = error;
      const ticket = result?.data?.ticket || "Ticket no Disponible";

      if (error) {
        message.error({
          content: `${process.env.REACT_APP_DOWNLOAD_ERROR_MESSAGE}${ticket}`,
          duration: 5,
          className: "custom-message",
        });
      }
    }
  };

  return (
    <Tooltip placement="left" title={<span>Solicitar Descarga</span>}>
      <Button
        type="text"
        shape="circle"
        icon={<CloudDownloadOutlined style={{ fontSize: "19px" }} />}
        onClick={handleOnClick}
        size={size}
        style={{
          marginRight: 5,
          backgroundColor: "white",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.4)",
        }}
        loading={inLoading}
      />
    </Tooltip>
  );
};

export default ExportButton;
